<template>
    <setup_frame title="Статистическая модель">
        <template v-slot:buttons>
            <div class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button v-if="!$root.not_editable && check_roles([ 'model' ]) && !new_coefs && Object.keys(data.coefs[type_en]).length !== 0" variant="outline-primary-secondary" @click="edit_coefs">
                    <span>Редактировать коэффициенты</span><base-icon name="pen" size="md" />
                </b-button>

                <b-button v-if="new_coefs" variant="outline-primary-secondary" @click="cancel_coefs">
                    <span>Отменить</span>
                </b-button>

                <b-button v-if="new_coefs" :disabled="!check_coefs" variant="primary" @click="save_coefs">
                    <span>Сохранить</span>
                </b-button>
            </div>
        </template>

        <b-form v-if="new_coefs">
            <b-form-group
                v-for="value, ind in new_coefs"
                :key="ind"
                :label="value.key"
                :label-for="`input-${ind}`"
                label-cols="3"
                content-cols="9"
                invalid-feedback="Некорректное значение"
                :state="value.value.length !== 0"
            >
				<b-form-input :id="`input-${ind}`" type="number" v-model="value.value" :state="value.value.length !== 0 && Number(value.value) >= 0" required></b-form-input>
            </b-form-group>
        </b-form>

        <span v-html="data.printable_formula_html[type_en]" />
    </setup_frame>
</template>

<script>

import api from "../../../../../../api"
import setup_frame from "../../setup_assets/frame"

export default {
    props :
    {
        id : String,
		group_id : String,
		data : Object,
    },

    components :
    {
        setup_frame
    },

    data()
    {
        return {

            new_coefs : null,

        }
    },

    computed :
    {
        check_coefs()
        {
			return ! this.new_coefs.find(coef => ( coef.value.length === 0 || Number(coef.value) < 0 ))
		},

		type_en()
		{
			if(this.data)
			{
				if(this.data.type == "Линейная")
					return "add"
				else if(this.data.type == "Мультипликативная степенная")
					return "mult"

				return "exp"
			}

			return null
		},
    },

    methods :
    {
        edit_coefs()
        {
            this.new_coefs = Object.values(this.data.coefs[this.type_en])
        },

        cancel_coefs()
        {
            this.new_coefs = null
        },

        save_coefs()
        {
            let new_coefs = this.new_coefs.map(coefs => ({ key : coefs.key, value : typeof coefs.value === "number" ? coefs.value : Number(coefs.value) }))
			var prepared_new_coefs = {}

			new_coefs.forEach(coef => { prepared_new_coefs[coef.key] = coef })

			api.call(this, "cadastral_cost_evaluation", "set_model_coefs", { id : this.id, type : this.data.type, coefs : prepared_new_coefs },
				response =>
				{
					this.data.printable_formula[this.type_en] = response.data.printable_formula
					this.data.printable_formula_html[this.type_en] = response.data.printable_formula_html
            
					this.cancel_coefs()
					this.$emit("need_refresh")
				})
        },

        check_roles(roles)
		{
			return api.check_roles(this, roles)
		}
    }
}

</script>

